import React, { createContext, useState } from 'react';

export const DevicesContext = createContext();

export const DevicesProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const [filterBody, setFilterBody] = useState();
  const [idFilter, setIdFilter] = useState([]);
  const [deviceNameFilter, setDeviceNameFilter] = useState([]);
  const [locationFilter, setLocationFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [errorDescriptionFilter, setErrorDescriptionFilter] = useState([]);
  const [dateTimeLtFilter, setDateTimeLtFilter] = useState();
  const [dateTimeGtFilter, setDateTimeGtFilter] = useState();
  const [sortOrder, setSortOrder] = useState('asc');

  const clearFilters = callback => {
    setIdFilter([]);
    setDeviceNameFilter([]);
    setLocationFilter([]);
    setErrorDescriptionFilter([]);
    setStatusFilter([]);

    setDateTimeGtFilter();
    setDateTimeLtFilter();

    setFilterBody();

    if (callback) callback();
  };

  return (
    <DevicesContext.Provider
      value={{
        page,
        setPage,
        filterBody,
        setFilterBody,
        idFilter,
        setIdFilter,
        statusFilter,
        setStatusFilter,
        deviceNameFilter,
        setDeviceNameFilter,
        locationFilter,
        setLocationFilter,
        errorDescriptionFilter,
        setErrorDescriptionFilter,
        dateTimeLtFilter,
        setDateTimeLtFilter,
        dateTimeGtFilter,
        setDateTimeGtFilter,
        sortOrder,
        setSortOrder,
        clearFilters,
      }}
    >
      {children}
    </DevicesContext.Provider>
  );
};
